/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState } from "react";
import { useTranslation } from "react-i18next";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import {
  estimateBill,
  estimateBasicFee,
  estimateUploadData,
  estimateDataTransfer,
} from "common/utils";

function PricingCards() {
  const { t } = useTranslation("pages");
  const [dayNumber, setDayNumber] = useState(0);
  const [siteNumber, setSiteNumber] = useState(0);
  const bill = estimateBill(siteNumber, dayNumber);
  const basicFee = estimateBasicFee(siteNumber);
  const uploadFee = estimateUploadData(dayNumber);
  const transferFee = estimateDataTransfer(dayNumber);

  return (
    <MDBox mt={8}>
      <MDBox textAlign="center">
        <MDTypography variant="h6" opacity={0.5}>
          {t("pricingEstimate.title")}
        </MDTypography>
      </MDBox>
      <MDBox mt={5} ml={{ xs: 0, lg: 0 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={12} lg={12}>
            {t("pricingEstimate.planPrefix")}
            <MDInput
              type="number"
              label={t("pricingEstimate.days")}
              onChange={(event) => setDayNumber(Number(event.target.value))}
            />
            {t("pricingEstimate.daysSuffix")}
            <MDInput
              type="number"
              label={t("pricingEstimate.dataPoints")}
              onChange={(event) => setSiteNumber(Number(event.target.value))}
            />
            {t("pricingEstimate.dataPointsSuffix", { bill })}
            <MDTypography variant="body2" mt={2}>
              {t("pricingEstimate.details", {
                basic: basicFee,
                upload: uploadFee,
                transfer: transferFee,
              })}
            </MDTypography>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default PricingCards;
